$(window).scroll(function(){var o=$(window).scrollTop(),e=$("#shopify-section-header").height();console.log(),console.log(),o>=e?$("#shopify-section-header").addClass("fixedtobar"):$("#shopify-section-header").removeClass("fixedtobar")});

var isXOScrollProcess = false;
		var xoScrollInterval = setInterval(function(){
		  if (typeof XOScroll2Top !== "undefined") {
			var xoscroll2top = new XOScroll2Top( 'xo-scroll2top', 600, [], false );
			xoscroll2top.init();isXOScrollProcess = true;
	}
	if (isXOScrollProcess) {
	  clearInterval(xoScrollInterval);
	}
  }, 1000);


$(document).ready( function(){
  $('.cm-seo-content #view-more').click(function(){
    $('.cm-seo-content').addClass('see-content');
  });
});